import axiosInstance from "./axiosInstance";

const DashboardService = {
    getDashboard: () =>
        axiosInstance.get('/api/dashboard').then(r => r.data),
};

export default DashboardService;
